import './Spacer.scss'

const Spacer = ({ space }) => {
  return <div className="spacer" style={{ height: `${space}px` }} />
}

export default Spacer
